import NonNachaFileImportPage from "components/pages/NonNachaFileImportPage";

/**
 * @name CaptureFileImport
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureFileImport(props) {
    return <NonNachaFileImportPage/>;
}